// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import IconFilterArrowDown from "@plumberssupply/XDL/Icons/IconFilterArrowDown";
import IconFilterArrowUp from "@plumberssupply/XDL/Icons/IconFilterArrowUp";
import { xBaseTheme } from "@plumberssupply/XDL/types";
import { color } from "@plumberssupply/XDL/Utilities";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        mergeCss: true,
        headerProps: {
            css: css`
                & > button {
                    &,
                    &:focus {
                        padding: 8px;
                        border: 1px solid ${color("common.ui7")};
                        background-color: ${color("common.white")};
                        outline: none;
                    }
                    &[aria-expanded="true"] {
                        &,
                        &:focus {
                            border-bottom-width: 0;
                        }
                    }
                }

                ${/* sc-selector */ AccordionSectionPanel} + & button {
                    border-top-width: 0;
                    border-bottom-width: 1px;
                    &:focus {
                        padding: 8px;
                        border-color: ${color("common.ui7")};
                        background-color: ${color("common.white")};
                        border-width: 0 1px 1px;
                        outline: none;
                    }
                    &[aria-expanded="true"] {
                        &,
                        &:focus {
                            border-top-width: 0;
                            border-bottom-width: 0;
                        }
                    }
                }
            `,
        },
        titleTypographyProps: {
            variant: "body",
            forwardAs: "span",
            weight: "bold",
            color: "text.main",
            size: 12,
        },
        toggleIconProps: {
            size: 15,
        },
        collapseIconProps: {
            color: "common.ui9",
            src: IconFilterArrowUp,
        },
        expandIconProps: {
            color: "text.main",
            src: IconFilterArrowDown,
        },
        panelProps: {
            css: css`
                padding: 12px 8px;
                background-color: ${color("common.ui12")};
                border: 1px solid ${color("common.ui7")};
                border-top: 0;
            `,
        },
    },
} as xBaseTheme["accordion"];
